import { Component, OnInit, ViewChild } from '@angular/core';
import { FileUploader } from 'ng2-file-upload';
import { HttpHeaders } from '@angular/common/http';
import { Subscription } from 'rxjs/Subscription';

import { AppComponentGenericComponent } from '../../custom/app-component-generic/app-component-generic.component';
import { DataService } from '../../../services/data.service';

@Component({
  selector: 'app-gestione-comuni',
  templateUrl: './gestione-comuni.component.html',
  styleUrls: ['./gestione-comuni.component.css']
})
export class GestioneComuniComponent extends AppComponentGenericComponent implements OnInit {
	@ViewChild('logoUpload') logoUpload: any;
	headers: HttpHeaders;
	comuniSync: Subscription;
	comuni: any[] = [];
	backupComune: any;
	uploader: FileUploader;
	working: boolean = false;

	nuovoComune: any = {
		cap: '',
		codice: '',
		civico_num: '',
		codice_fiscale: '',
		rea: '',
		email: '',
		fax: '',
		indirizzo: '',
		nome: '',
		nome_lungo: '',
		partita_iva: '',
		pec: '',
		provincia: '',
		telefono: '',
		tipo_interesse: '',
		ufficio_spedizioni: ''
	}

	selectedComune: any = {
		id: '',
		cap: '',
		codice: '',
		civico_num: '',
		codice_fiscale: '',
		rea: '',
		email: '',
		fax: '',
		indirizzo: '',
		nome: '',
		nome_lungo: '',
		partita_iva: '',
		pec: '',
		provincia: '',
		telefono: '',
		tipo_interesse: '',
		ufficio_spedizioni: ''
	}

	constructor(protected dataService: DataService) {
		super(dataService, 'gestione-comuni');
		this.headers = new HttpHeaders();
		this.headers.append('Content-Type', 'application/json');
		this.headers.append('Accept', 'application/json');
		this.uploader = new FileUploader({url: '/api/comuni/carica_logo' });
		this.uploader.onCompleteAll = () => {
			console.log("logo comune caricato");
			this.resetSelectedComune();
		};
	}

	ngOnInit() {
		this.dataService.setPageOpened('/gestione-comuni');
		this.comuniSync = this.dataService.getComuniService().comuniDisponibili$.subscribe(
			comuniDisponibili => {
				this.comuni = comuniDisponibili;
				console.log('gestione-comuni', this.comuni);
			});
	}

	resetNuovoComune() {
		this.nuovoComune = {
			id: '',
			cap: '',
			codice: '',
			civico_num: '',
			codice_fiscale: '',
			rea: '',
			email: '',
			fax: '',
			indirizzo: '',
			nome: '',
			nome_lungo: '',
			partita_iva: '',
			pec: '',
			provincia: '',
			telefono: '',
			tipo_interesse: '',
			ufficio_spedizioni: ''
		}
		this.working = false;
		this.dataService.closeLoader();
	}

	resetSelectedComune() {
		this.selectedComune = {
			id: '',
			cap: '',
			codice: '',
			civico_num: '',
			codice_fiscale: '',
			rea: '',
			email: '',
			fax: '',
			indirizzo: '',
			nome: '',
			nome_lungo: '',
			partita_iva: '',
			pec: '',
			provincia: '',
			telefono: '',
			tipo_interesse: '',
			ufficio_spedizioni: ''
		}
		this.working = false;
		this.dataService.closeLoader();
	}

	selectNuovoComune() {
		this.selectedComune.id = '';
		console.log(this.selectedComune.id);
	}

	editaComune(comune: any) {
		if (this.uploader.queue.length) {
			this.emptyUpload();
		}
		for (let key in comune) {
			this.selectedComune[key] = comune[key];
		}
	}

	resetEditaComune() {
		for (let comune of this.comuni) {
			if (comune.id == this.selectedComune.id) {
				this.editaComune(comune);
				return true;
			}
		}
	}

	aggiornaComune() {
		console.log('aggiorna comune', this.selectedComune);
		this.working = true;
		this.dataService.openLoader('MODIFICA COMUNE','aggiornamento del nuovo comune in corso...');
		let localFilters = [];
		localFilters.push({ type: "=", key: "id", value: this.selectedComune.id });

		this.dataService.update("comuni", localFilters, this.selectedComune, false, (error,res) => {
			if(res){
				if (this.uploader.queue.length) {
					console.log('LOGO DA CARICARE');
					this.uploader.queue[0].file.name = this.selectedComune.codice+'.png';
					this.uploader.queue[0].upload();
				}else {
					this.resetSelectedComune();
				}
				this.dataService.openMessage('MODIFICA COMUNE','Comune modificato con successo');
			}
		});
	}

	aggiungiComune() {
		console.log('aggiungi comune', this.nuovoComune);
		this.working = true;
		this.dataService.openLoader('INSERIMENTO COMUNE','aggiunta del nuovo comune in corso...');
		this.nuovoComune.codice = this.parseName(this.nuovoComune.nome);

		this.dataService.insert("comuni", this.nuovoComune, false, (error,newId) => {
			if (error) {
				this.dataService.closeLoader();
				//this.dataService.openMessage('INSERIMENTO COMUNE','si è verificato un errore');
				this.working = false;
			}
			if(newId){
				this.addDefaultFlow(newId);
			}
		});
	}

	addDefaultFlow(newId) {
		this.dataService.getElementsByKey('flussi_pratica','id','1',false,(result) => {
			let flussoDefault = result[0];
			flussoDefault['comune_id'] = newId;
			delete flussoDefault['id'];

			this.dataService.insertFlow(flussoDefault, (error,flowId) => {
				if (error) {
					this.dataService.closeLoader();
					this.dataService.openMessage('INSERIMENTO COMUNE','si è verificato un errore');
					this.working = false;
				}
				else {
					console.log('nuovo flusso',flowId);
					this.setupComune();
				}
			});
		});
	}

	// eliminaComune(id: any) {
	// 	console.log('elimina comune:',id);
	// 	let url: string = 'api/comuni/rimuovi';
	// 	let removedComune = {};
	// 	let body: any = {};
	// 	let localFilters = [];
	// 	localFilters.push({ type: "=", key: "id", value: id });

	// 	for(let comune of this.comuni){
	// 		if(comune.id == id){
	// 			this.selectedComune = comune;
	// 			body.comune = comune;
	// 		}
	// 	}
	// 	//console.log(id, this.selectedComune, this.comuni);
	// 	this.dataService.getCommon().getHttpClient().post<any>(url,	JSON.stringify(body), { headers: this.headers })
	// 		.subscribe(
	// 			response => {
	// 				console.log('rimozione comune', response);
	// 				this.dataService.openMessage('RIMOZIONE COMUNE','Comune rimosso con successo');
	// 				this.resetNuovoComune();
	// 				this.dataService.delete("comuni", localFilters, true, (error,res) => {
	// 					this.selectedComune.id = '';
	// 				});
	// 			}
	// 		);

	// }

	abilitaComune(id: any) {
		console.log('abilita comune:',id);
		let localFilters = []
		localFilters.push({ type: "=", key: "id", value: id });
		this.dataService.update('comuni', localFilters, {attivo:1}, false, (error, res) => {
			if (error) {
				console.log('errore',error);
			}
			else {
				console.log('res',res);
			}
		});
	}

	disabilitaComune(id: any) {
		console.log('disabilita comune:',id);
		let localFilters = []
		localFilters.push({ type: "=", key: "id", value: id });
		this.dataService.update('comuni', localFilters, {attivo:0}, false, (error, res) => {
			if (error) {
				console.log('errore',error);
			}
			else {
				console.log('res',res);
			}
		});
	}

	setupComune() {
		let url: string = 'api/comuni/crea';
		let body: any = {
			comune: this.nuovoComune
		};

		this.dataService.getCommon().getHttpClient().post<any>(url,	JSON.stringify(body), { headers: this.headers })
			.subscribe(
				response => {
					console.log('creazione comune', response);
					if (this.uploader.queue.length) {
						this.uploader.queue[0].file.name = this.nuovoComune.codice;
						this.uploader.queue[0].upload();
					}
					this.resetNuovoComune();
					this.dataService.openMessage('INSERIMENTO COMUNE','Comune inserito con successo');
				}
			);
	}

	parseName(toParse: string) {
		let parsed: string = toParse.toLowerCase()
									.replace("'","")
									.replace('"','')
									.replace("à","a")
									.replace("è","e")
									.replace("é","e")
									.replace("ì","i")
									.replace("ò","o")
									.replace("ù","u")
									.split(" ")
									.join("-");
		return parsed;
	}

	canAdd() {
		if (
			!this.working &&
			this.nuovoComune.cap &&
			this.nuovoComune.civico_num &&
			(this.nuovoComune.codice_fiscale || this.nuovoComune.partita_iva) &&
			this.nuovoComune.email &&
			this.nuovoComune.indirizzo &&
			this.nuovoComune.nome &&
			this.nuovoComune.provincia &&
			this.nuovoComune.telefono &&
			this.uploader.queue.length
			) {
			return true;
		}
		else {
			return false;
		}
	}

	canUpdate() {
		if (
			!this.working &&
			this.selectedComune.cap &&
			this.selectedComune.civico_num &&
			(this.selectedComune.codice_fiscale || this.selectedComune.partita_iva) &&
			this.selectedComune.email &&
			this.selectedComune.indirizzo &&
			this.selectedComune.nome &&
			this.selectedComune.provincia &&
			this.selectedComune.telefono
			) {
			return true;
		}
		else {
			return false;
		}
	}

	emptyUpload() {
		this.uploader.clearQueue();
		this.logoUpload.nativeElement.value = '';
	}
}
